import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

export default function HowTo() {
  const { t } = useTranslation();
  const steps = [0, 1, 2];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        gap: 3,
        maxWidth: 900,
        margin: "0 auto",
      }}
    >
      {steps.map((i) => (
        <Card
          key={i}
          sx={{
            flex: 1,
            border: "1px solid #E2E8F0",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: 200,
              backgroundImage: `url(${t("picdict.how_to." + i + ".img")})`,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundColor: "#F8FAFC",
            }}
          />
          <CardContent sx={{ p: 3 }}>
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: 28,
                height: 28,
                borderRadius: "50%",
                backgroundColor: "#3B82F6",
                color: "#FFFFFF",
                fontWeight: 700,
                fontSize: "0.8rem",
                mb: 1.5,
              }}
            >
              {i + 1}
            </Box>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ lineHeight: 1.8, fontSize: "0.88rem" }}
            >
              {t("picdict.how_to." + i + ".detail")}
            </Typography>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
}
